import {
  CertificationEquipmentLinkCreateInput,
  CertificationEquipmentLinkUpdateInput,
  CreateCertificationEquipmentLinkMutation,
  CreateCertificationEquipmentLinkMutationVariables,
  UpdateCertificationEquipmentLinkMutation,
  UpdateCertificationEquipmentLinkMutationVariables,
} from '__generated__/graphql';
import gql from 'graphql-tag';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { isNil } from 'lodash';
import { CERTIFICATION_EQUIPMENT_LINK_FRAGMENT } from './useCertificationEquipmentLinks';

export function useMutateCertificationEquipmentLinks() {
  const client = useGraphQLClient();

  async function createCertificationEquipmentLink(input: CertificationEquipmentLinkCreateInput) {
    const result = await client.request<
      CreateCertificationEquipmentLinkMutation,
      CreateCertificationEquipmentLinkMutationVariables
    >({
      document: CREATE_CERTIFICATION_EQUIPMENT_LINK,
      variables: {
        certificationEquipmentLink: input,
      },
    });

    if (isNil(result.createCertificationEquipmentLink)) {
      throw Error(`result was ${result.createCertificationEquipmentLink}`);
    }

    return result.createCertificationEquipmentLink;
  }

  async function updateCertificationEquipmentLink(input: CertificationEquipmentLinkUpdateInput) {
    const result = await client.request<
      UpdateCertificationEquipmentLinkMutation,
      UpdateCertificationEquipmentLinkMutationVariables
    >({
      document: UPDATE_CERTIFICATION_EQUIPMENT_LINK,
      variables: {
        certificationEquipmentLink: input,
      },
    });

    if (isNil(result.updateCertificationEquipmentLink)) {
      throw Error(`result was ${result.updateCertificationEquipmentLink}`);
    }

    return result.updateCertificationEquipmentLink;
  }

  return {
    createCertificationEquipmentLink,
    updateCertificationEquipmentLink,
  };
}

export const UPDATE_CERTIFICATION_EQUIPMENT_LINK = gql`
  mutation UpdateCertificationEquipmentLink($certificationEquipmentLink: CertificationEquipmentLinkUpdateInput) {
    updateCertificationEquipmentLink(certificationEquipmentLink: $certificationEquipmentLink) {
      ...CertificationEquipmentLinkFragment
    }
  }
  ${CERTIFICATION_EQUIPMENT_LINK_FRAGMENT}
`;

export const CREATE_CERTIFICATION_EQUIPMENT_LINK = gql`
  mutation CreateCertificationEquipmentLink($certificationEquipmentLink: CertificationEquipmentLinkCreateInput) {
    createCertificationEquipmentLink(certificationEquipmentLink: $certificationEquipmentLink) {
      ...CertificationEquipmentLinkFragment
    }
  }
  ${CERTIFICATION_EQUIPMENT_LINK_FRAGMENT}
`;
